import api from "./api";

// ── Admin — partner org management ──────────────────────────────────────────

export const createPartnerOrg = (data) =>
  api.post("/partner-orgs/", data);

export const listPartnerOrgs = () =>
  api.get("/partner-orgs/");

export const getPartnerOrg = (id) =>
  api.get(`/partner-orgs/${id}/`);

export const updatePartnerOrg = (id, data) =>
  api.patch(`/partner-orgs/${id}/`, data);

export const getPartnerOrgBilling = (id) =>
  api.get(`/partner-orgs/${id}/billing/`);

// Public — no auth required
export const getPublicPartnerOrgs = () =>
  api.get("/partner-orgs/public/");

// ── Partner portal ───────────────────────────────────────────────────────────

export const getPortalPatients = () =>
  api.get("/partner-portal/patients/");

export const getPortalPatientPrescriptions = (patientPin) =>
  api.get(`/partner-portal/patients/${patientPin}/prescriptions/`);

export const getPortalPickupQueue = () =>
  api.get("/partner-portal/pickup-queue/");

export const getPortalBilling = () =>
  api.get("/partner-portal/billing/");

// ── Partner notifications ────────────────────────────────────────────────────

export const getPartnerNotifications = () =>
  api.get("/partner-portal/notifications/");

export const getPartnerNotificationUnreadCount = () =>
  api.get("/partner-portal/notifications/unread-count/");

export const markPartnerNotificationRead = (id) =>
  api.patch(`/partner-portal/notifications/${id}/mark-read/`);

export const markAllPartnerNotificationsRead = () =>
  api.post("/partner-portal/notifications/mark-all-read/");

// ── Admin — pickup partners (new PartnerOrganisation model) ──────────────────

export const listPickupPartners = () =>
  api.get("/partner-orgs/");

export const createPickupPartner = (data) =>
  api.post("/partner-orgs/", data);

export const updatePickupPartner = (id, data) =>
  api.patch(`/partner-orgs/${id}/`, data);

export const getPickupPartnerBilling = (id) =>
  api.get(`/partner-orgs/${id}/billing/`);

// ── Patient — pickup authorisation update ────────────────────────────────────

export const updatePrescriptionPickup = (prescriptionId, data) =>
  api.patch(`/prescriptions/${prescriptionId}/pickup/`, data);
